var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgIcebergAnimal1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "34px",
    viewBox: "0 0 88 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_152368-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_152368-2",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2,21.5 C19.4,21.5 18.7,20.8 18.7,20 C18.7,10.9 11.3,3.5 2.2,3.5 C1.4,3.5 0.7,2.8 0.7,2 C0.7,1.2 1.4,0.5 2.2,0.5 C13,0.5 21.7,9.2 21.7,20 C21.7,20.8 21,21.5 20.2,21.5 L20.2,21.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,21.5 C19.4,21.5 18.7,20.8 18.7,20 C18.7,9.2 27.4,0.5 38.2,0.5 C39,0.5 39.7,1.2 39.7,2 C39.7,2.8 39,3.5 38.2,3.5 C29.1,3.5 21.7,10.9 21.7,20 C21.7,20.8 21,21.5 20.2,21.5 L20.2,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 18.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8,15.5 C13,15.5 12.3,14.8 12.3,14 C12.3,8.2 7.6,3.5 1.8,3.5 C1,3.5 0.3,2.8 0.3,2 C0.3,1.2 1,0.5 1.8,0.5 C9.2,0.5 15.3,6.6 15.3,14 C15.3,14.8 14.6,15.5 13.8,15.5 L13.8,15.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8,15.5 C13,15.5 12.3,14.8 12.3,14 C12.3,6.6 18.4,0.5 25.8,0.5 C26.6,0.5 27.3,1.2 27.3,2 C27.3,2.8 26.6,3.5 25.8,3.5 C20,3.5 15.3,8.2 15.3,14 C15.3,14.8 14.6,15.5 13.8,15.5 L13.8,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.000000, 18.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2,15.5 C13.4,15.5 12.7,14.8 12.7,14 C12.7,8.2 8,3.5 2.2,3.5 C1.4,3.5 0.7,2.8 0.7,2 C0.7,1.2 1.4,0.5 2.2,0.5 C9.6,0.5 15.7,6.6 15.7,14 C15.7,14.8 15,15.5 14.2,15.5 L14.2,15.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,15.5 C13.4,15.5 12.7,14.8 12.7,14 C12.7,6.6 18.8,0.5 26.2,0.5 C27,0.5 27.7,1.2 27.7,2 C27.7,2.8 27,3.5 26.2,3.5 C20.4,3.5 15.7,8.2 15.7,14 C15.7,14.8 15,15.5 14.2,15.5 L14.2,15.5 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcebergAnimal1);
export default __webpack_public_path__ + "static/media/bg-iceberg-animal1.0d006666ea099482edf1220976e611e9.svg";
export { ForwardRef as ReactComponent };